import { Controller, Payload } from "../../config/controller";
import { ApplicationState } from "../../../core/store";
import { bindActionCreators, Dispatch } from "redux";

import { Usuario, initialValueUsuarioState, UsuarioState, UsuarioActions } from "./usuario.model"
import { action } from "typesafe-actions";
import { call, put, takeLatest } from "redux-saga/effects";
import { ResultDb } from "../../services/db";
import { StatusAppActions, StatusAppState } from "../root/root.model";
import { statusAppController } from "../root/root.controller";

export interface UsuarioViewProps {
    usuarioState: UsuarioState
    usuarioActions: UsuarioActions
    statusAppState: StatusAppState
    statusAppActions: StatusAppActions
}


class UsuarioController extends Controller<Usuario, UsuarioState, UsuarioActions> {
    constructor() {
        super(initialValueUsuarioState.row.type, initialValueUsuarioState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
            LOGIN: `@${this.moduloName}/LOGIN`,
            LOGOFF:`@${this.moduloName}/LOGOFF`
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
            login: (login, senha) => action(this.actionsType.LOGIN, { login, senha }),
            logOff: () => action(this.actionsType.LOGOFF),
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
            takeLatest(this.actionsType.LOGIN, this.loginActionEffects.bind(this)),
            takeLatest(this.actionsType.LOGOFF, this.logOffActionEffects.bind(this))
        ]
    }

    private * loginActionEffects(actions: Payload) {
        try {
            let login = actions.payload.login;
            let senha = btoa(actions.payload.senha);
            if (login !== "") {
                //os usuarios ja foram carregados na inicializacao em startApp
                let resp:ResultDb<Usuario> = yield call(this.read,{
                    fieldsFilter:[{fieldName:"login",mangoQuery:"$eq",fieldValue:login}],
                    indexName:"index_login_usuario"
                });
                console.log("resp da busca de usuario")
                if (resp.status && resp.rows && resp.rows.length > 0) {
                    let userFind = resp.rows.find(row=>row.senha === senha);
                    if (userFind && userFind._id) {
                        yield put(this.reducer.resultAfterEffects(
                            { ...this.state, loading: false, status: "ok", rowLogado:userFind , msg: "Usuario logado com sucesso!" },
                            this.actionsType.loginActionEffects
                        ))
                    } else {
                        yield put(this.reducer.resultAfterEffects(
                            { ...this.state, loading: false, status: "error", error: true, showAlert: true, msg: "Senha incorreta!" },
                            this.actionsType.loginActionEffects
                        ))
                    }
                } else {
                    yield put(this.reducer.resultAfterEffects(
                        { ...this.state, loading: false, status: "error", error: true, showAlert: true, msg: "Usuários não encontrado, reinicie o sistema!" },
                        this.actionsType.loginActionEffects
                    ))
                }

            }
        } catch (error: any) {
            console.log("error loginActionEffects", error);
            let msg = "Ops, ocorreu uma falha em loginActionEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.loginActionEffects
            ))
        }
    }

    private * logOffActionEffects(actions: Payload) {
        try {
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, status: "ok", rowLogado:{} as Usuario , msg: "LogOff do usuário." },
                this.actionsType.logOffActionEffects
            ))
            
        } catch (error: any) {
            console.log("error logOffActionEffects", error);
            let msg = "Ops, ocorreu uma falha em logOffActionEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.logOffActionEffects
            ))
        }
    }


    private * usuarioReadAllEffects(actions: Payload) {

    }
}

export const usuarioController = new UsuarioController()

export const mapStateToUsuarioProps = (state: ApplicationState) => ({
    usuarioState: state.usuarioState,
    statusAppState: state.statusAppState,
})

export const mapDispatchToUsuarioProps = (dispatch: Dispatch) => ({
    usuarioActions: bindActionCreators({ ...usuarioController.reducer.actions }, dispatch),
    statusAppActions: bindActionCreators({ ...statusAppController.reducer.actions }, dispatch),
})